"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_AGGREGATED_TEXT_ATTRIBUTES = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_AGGREGATED_TEXT_ATTRIBUTES = (0, gql_1.gql)(`
  query AggregatedTextAttributes(
    $productTreeNodeId: ID!,
    $catalogId: ID!,
    $filter: ProductAggregatedLabelNewFilter!,
    $sort: ProductAggregatedLabelNewOrderBy,
    $first: Int,
    $after: ID,
    $last: Int,
    $before: ID,
  ) {
    productTreeNode(id: $productTreeNodeId) {
      id
      productAggregatedLabelsNew(catalog: $catalogId, filter: $filter, sort: $sort, first: $first, after: $after, last: $last, before: $before) {
        edges {
          node {
            label
            productCount
            productLabelValidations {
              totalCount
            }
          }
        }
        pageInfo {
          startCursor
          endCursor
          hasNextPage
        }
      }
    }
  }
`);
